// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.entity-icon__container {
  display: flex;
  align-items: center;
  justify-content: center;
}
.entity-icon__container_size_s {
  height: 24px;
  width: 24px;
}
.entity-icon__container_size_s .entity-icon__color-box {
  height: 18px;
  width: 18px;
}
.entity-icon__container_size_m {
  width: 28px;
  height: 28px;
}
.entity-icon__container_size_m .entity-icon__color-box {
  height: 20px;
  width: 20px;
}
.entity-icon__container_size_l {
  width: 32px;
  height: 32px;
}
.entity-icon__container_size_l .entity-icon__color-box {
  height: 22px;
  width: 22px;
}
.entity-icon__container_size_xl {
  width: 36px;
  height: 36px;
}
.entity-icon__container_size_xl .entity-icon__color-box {
  height: 28px;
  width: 28px;
  border-radius: 6px;
}
.entity-icon__container_view_round .entity-icon__color-box {
  height: 100%;
  width: 100%;
  border-radius: 50%;
}
.entity-icon__color-box {
  display: flex;
  align-items: center;
  border-radius: 4px;
  justify-content: center;
  color: var(--g-color-text-light-primary);
}
.entity-icon__color-box_type_dataset {
  background-color: var(--dl-color-entity-dataset);
}
.entity-icon__color-box_type_chart-wizard {
  background-color: var(--dl-color-entity-chart-wizard);
}
.entity-icon__color-box_type_chart-ql {
  background-color: var(--dl-color-entity-chart-ql);
}
.entity-icon__color-box_type_editor {
  background-color: var(--dl-color-entity-chart-editor);
}
.entity-icon__color-box_type_dashboard {
  background-color: var(--dl-color-entity-dashboard);
}
.entity-icon__color-box_type_connection {
  background-color: var(--dl-color-entity-connection);
}
.entity-icon__color-box_type_broken {
  background-color: var(--g-color-base-misc-heavy);
}`, "",{"version":3,"sources":["webpack://./src/ui/components/EntityIcon/EntityIcon.scss"],"names":[],"mappings":"AAGI;EACI,aAAA;EACA,mBAAA;EACA,uBAAA;AAFR;AAIQ;EACI,YAAA;EACA,WAAA;AAFZ;AAIY;EACI,YAAA;EACA,WAAA;AAFhB;AAMQ;EACI,WAAA;EACA,YAAA;AAJZ;AAMY;EACI,YAAA;EACA,WAAA;AAJhB;AAQQ;EACI,WAAA;EACA,YAAA;AANZ;AAQY;EACI,YAAA;EACA,WAAA;AANhB;AAUQ;EACI,WAAA;EACA,YAAA;AARZ;AAUY;EACI,YAAA;EACA,WAAA;EACA,kBAAA;AARhB;AAaY;EACI,YAAA;EACA,WAAA;EACA,kBAAA;AAXhB;AAgBI;EACI,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,uBAAA;EACA,wCAAA;AAdR;AAgBQ;EACI,gDAAA;AAdZ;AAiBQ;EACI,qDAAA;AAfZ;AAkBQ;EACI,iDAAA;AAhBZ;AAmBQ;EACI,qDAAA;AAjBZ;AAoBQ;EACI,kDAAA;AAlBZ;AAqBQ;EACI,mDAAA;AAnBZ;AAsBQ;EACI,gDAAA;AApBZ","sourcesContent":[".entity-icon__container {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.entity-icon__container_size_s {\n  height: 24px;\n  width: 24px;\n}\n.entity-icon__container_size_s .entity-icon__color-box {\n  height: 18px;\n  width: 18px;\n}\n.entity-icon__container_size_m {\n  width: 28px;\n  height: 28px;\n}\n.entity-icon__container_size_m .entity-icon__color-box {\n  height: 20px;\n  width: 20px;\n}\n.entity-icon__container_size_l {\n  width: 32px;\n  height: 32px;\n}\n.entity-icon__container_size_l .entity-icon__color-box {\n  height: 22px;\n  width: 22px;\n}\n.entity-icon__container_size_xl {\n  width: 36px;\n  height: 36px;\n}\n.entity-icon__container_size_xl .entity-icon__color-box {\n  height: 28px;\n  width: 28px;\n  border-radius: 6px;\n}\n.entity-icon__container_view_round .entity-icon__color-box {\n  height: 100%;\n  width: 100%;\n  border-radius: 50%;\n}\n.entity-icon__color-box {\n  display: flex;\n  align-items: center;\n  border-radius: 4px;\n  justify-content: center;\n  color: var(--g-color-text-light-primary);\n}\n.entity-icon__color-box_type_dataset {\n  background-color: var(--dl-color-entity-dataset);\n}\n.entity-icon__color-box_type_chart-wizard {\n  background-color: var(--dl-color-entity-chart-wizard);\n}\n.entity-icon__color-box_type_chart-ql {\n  background-color: var(--dl-color-entity-chart-ql);\n}\n.entity-icon__color-box_type_editor {\n  background-color: var(--dl-color-entity-chart-editor);\n}\n.entity-icon__color-box_type_dashboard {\n  background-color: var(--dl-color-entity-dashboard);\n}\n.entity-icon__color-box_type_connection {\n  background-color: var(--dl-color-entity-connection);\n}\n.entity-icon__color-box_type_broken {\n  background-color: var(--g-color-base-misc-heavy);\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
